import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./home_page/HomePage";
import SponsorPage1 from "./sponsor_page/SponsorPage";
import ContactUsPage from "./contact_us/ContactUs";
import AboutUsPage from "./about_us/AboutUs";
import EventPageWithNav from "./event_page/EventPageWithNav";
import EventPopupPageWithNav from "./event_page/EventPopupPageWithNav";
import Collab from "./collab/collab_page";
import OurTeam from "./our_team/OurTeam";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/sponsor" element={<SponsorPage1 />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/events" element={<EventPageWithNav />} />
        <Route path="/events/view" element={<EventPopupPageWithNav />} />
        <Route path="/aboutus" element={<AboutUsPage />} />
        <Route path="/collab" element={<Collab />} />
        <Route path="/ourteam" element={<OurTeam />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;